import { makeStyles } from 'tss-react/mui';

const name = 'ProjectSkeleton';

export const useProjectSkeletonStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: theme.spacing(3, 0),

    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  left: {
    display: 'flex',
    gap: theme.spacing(3),
  },
}));
